// Kiểm tra có cần hiện tour hay không; tách riêng để App.js không phải nạp cả AppTourV2
export const ONBOARDING_STORAGE_KEY = 'onboarding_seen_once_v4';

export const shouldShowOnboardingV2 = () => {
  try {
    return !localStorage.getItem(ONBOARDING_STORAGE_KEY);
  } catch (_) {
    return true;
  }
};
